import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { FetchUserInfoSuccessResponse } from '@/modules/Auth/types/api/response/userInfo'
import { axiosInstance } from '@/modules/Core/plugins/axios'

const QUERY_KEY = 'user-info'
const ENDPOINT = '/tripmentor/User/Info'

export function fetchUserInfo() {
  return axiosInstance
    .get<FetchUserInfoSuccessResponse>(ENDPOINT, {})
    .then((response) => response.data)
}

function useUserInfoQuery(
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchUserInfo>>>
) {
  return useQuery({
    queryFn: () => fetchUserInfo(),
    queryKey: [QUERY_KEY],
    ...options,
  })
}

export default useUserInfoQuery
